function upSellslider(){
  if(!(document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
  if(!(document.querySelector('.drawer__inner-empty.is-empty'))){
    $('.cdk_upsell_slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 2, 
      slidesToScroll: 1, 
      adaptiveHeight: true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll:1,
           arrows: true
          }
        }
      ]
  });
  }
  }
}
  
//Ajax Cart Count Function Start
function cartCount(){ $.getJSON('/cart.js', function(cart) { $(".cart-count-bubble > span").html(cart.item_count); 
    if(cart.item_count >= 1){$('cart-drawer.cdesk-cart-drawer').removeClass('is-empty').addClass('active'); $('body').addClass('overflow-hidden');
    $('#cart-icon-bubble').append('<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' items</span></div>')}
    });
}
//  mini cart 
function updateMiniCart(currentThis) {
  $.ajax({
    type: "GET",
    url: "/",
    dataType: "html",

    success: function (data) {
      var miniCartHead = $(data).contents("#CartDrawer").find(".drawer__inner").html();
      $("#CartDrawer .drawer__inner").html(miniCartHead);
      setTimeout(function () {   
          upSellslider();
        },1500);
      
    },
  });
}
//  Ajax Cart Count Function End 
function ajaxAddToCartProduct(currentThis,dynamicData,variantId) {   
 $.post('/cart/add.js', { id: variantId, quantity: 1 }, function() {
   $('body').addClass('overflow-hidden');
        updateMiniCart(currentThis); 
        cartCount();

        setTimeout(function () {   
          upSellslider();
        },1500);
 });
  /*
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: {items:dynamicData},
      dataType: "json",
      success: function(data){  
        $('body').addClass('overflow-hidden');
        updateMiniCart(currentThis); 
        cartCount();

        setTimeout(function () {   
          upSellslider();
        },1500);
              
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
      }
    });
    */
  }

$(document).ready(function(){
  // bundle option selected js
  $(document).mouseup(function (e) {
    if ($(e.target).closest(".swatches-block-box").length === 0) {
        $(".swatches-block-box").removeClass('open');
    }
  });
  
  $(document).on('click','.swatches-block .option_label', function () {
    $(this).next('.swatches-block-box').addClass('open');
  })
  $(document).on('click','.cdk_upsell_outer .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    $(this).parents('.swatches-block-box').removeClass('open');
    if(window.innerWidth < 788){
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName.substring(0, 13)+'...');
    }else{
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName);
    }
  })

 
  $(document).on('change','.cdk_upsell_outer .swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    
    $('.product-swatches[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
    });
    $(this).parents('.card__content').find('.ancprice').hide();
    $('.ancprice[ var-id="' + $(this).find('option:selected').attr('v-id') + '"]').show();
    
      $(this).parents('.card-wrapper').find('.card__media').addClass('hidden');
      $(this).parents('.card-wrapper').find('.card__media[v-id="' + $(this).find('option:selected').attr('v-id') + '"]').removeClass('hidden');
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    $(this).parents('.swatches-block').find('.option_label').css('font-size','0');
    $(this).parents('.swatches-block').find('.option_label').find('span').css('display','block');     
    var optionName_Selector = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]');
    var optionName_val = optionName_Selector.val(); 
    $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change(); 
  });
  $(document).on('change','.cdk_upsell_outer .product-swatches select.product_card-form__master-select', function () {
$(this).parents('.card-wrapper').find('.card__media').addClass('hidden');
      $(this).parents('.card-wrapper').find('.card__media[v-id="' + $(this).find('option:selected').attr('value') + '"]').removeClass('hidden');
    $(this).parents('.card__content').find('.ancprice').hide();
    $('.ancprice[ var-id="' + $(this).find('option:selected').attr('value') + '"]').show();
    
    var thisMainVal = $(this).val(); 
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    // console.log('thisMainVal::'+thisMainVal);
    var ThisSellingPlan = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val();
    // console.log('ThisSellingPlan::'+ThisSellingPlan);
    var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
    // console.log('ThisProdAvail::'+ThisProdAvail);
      $('.upsell-addto-cart').attr('data-variant',ThisSellingPlan);
      
  });
$(document).on('click','.upsell-addto-cart',function(){   
  var currentThis = $(this);
  var updateItems = [];
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;
  updateItems.push({ "id": variantId, "quantity": quantity});
  ajaxAddToCartProduct(currentThis,updateItems,variantId);
  setTimeout(function () {   
      upSellslider();
    },1500);  
});
$(document).on("click", ".cdkCart-wrapper cart-remove-button button", function (event) {
    event.preventDefault();    
    var vId = $(this).parents(".cart-item__quantity-wrapper").find('.quantity__input').attr('data-quantity-variant-id');      
   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
     data: {
    'id': parseFloat(vId),
    'quantity': 0
    }
   })
   .then(data => {
     $(this).parents('.cart-item').remove();
     var Lenght = $('.cart-items .cart-item').length;
     cartCount();
     updateMiniCart();
     if (Lenght == 0){
       $('cart-drawer.cdkCart-wrapper').addClass('is-empty');
     }
     setTimeout(function () {   
        upSellslider();
      },1000);
  })
  });
$(document).on("change", ".cdkCart-wrapper .cart-quantity .quantity__input", function () {   
    var vId = $(this).attr('data-quantity-variant-id'); 
    var itemValue = $(this).val();
   $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: {'id': vId,
    'quantity': itemValue},
      success: function(data) { 
         cartCount();
         updateMiniCart();
        setTimeout(function () {   
          upSellslider();
        },1500);
      },
      error: function(jqxhr, status, exception) {
      } 
    })
});
  $(document).on("click","#addToCart",function () {
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;  
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { "id": variantId, "quantity": quantity},
      dataType: "json",
      success: function(data){  
        $('body').addClass('overflow-hidden');
        updateMiniCart(); 
        cartCount();
        
        setTimeout(function () {  
            
          upSellslider();
          
          $('.cdkCart-wrapper').addClass('active');
          
        },1500);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
      }
    });




    
  });
$(document).on('click', '.product-form__submit,.header__icon--cart', function(){
  if(!(document.querySelector('.drawer__inner-empty.is-empty') && document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
  setTimeout(function () {   
    upSellslider();
  },1000);
  }
}) 
 $(document).on('click', '.pf-product-form button', function(){ 
   $('body').addClass('overflow-hidden'); 
  setTimeout(function () {   
    upSellslider();
  },1500);
});

// Product sticky bar
 $(document).on("click",".product-sticky-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
    var OptionName = $(this).attr("data-value");
    $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
    $(this).addClass("selected");
    $(this).parents(".swatches-block").find("select").val(OptionName).change();
    
});

  $(document).on("change",".product-sticky-wrapper  .swatches-block select.cdk-select",function () {
    var FinalValue = "";
    $('.product-sticky-wrapper .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
    });
    
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    var optionName_Selector = $('.product-sticky-wrapper select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
    var optionName_val = optionName_Selector.val();
    $('.product-sticky-wrapper select.product_card-form__master-select').val(optionName_val).change();
  });


  
  $(document).on("change",".product-sticky-wrapper select.product_card-form__master-select",function () {
      var thisMainVal = $(this).val();
      var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
      var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
      $(this).parents('.product-sticky-wrapper').find(".cdk_quick_price").find(".price-item.price-item--regular").text(ThisProdNP);
      $('.cdk_custom_add').attr("data-variant",thisMainVal);
      $('.cdk-custom-change').attr('value',thisMainVal);
      if (ThisProdAvail == "true") {
        $('.cdk_custom_add').attr("data-btn","addToCart");
        $('.cdk_custom_add').find(".btn_text").text("Add To Cart");
      } else {
        $('.cdk_custom_add').find(".btn_text").text("Sold Out");
        $('.cdk_custom_add').attr("data-btn","soldout");
      }
    });
  $(document).on("click","fieldset.cdk--option-1 label",function () {
    var stickyOptionChange = $(this).prev().val();
    $(".product-sticky-wrapper .swatches-block.sticky-option-1").find("select").val(stickyOptionChange).change();
    $(".product-sticky-wrapper .sticky-option-1 .cdk-selected-option_item").text(stickyOptionChange);
  });
  $(document).on("click","fieldset.cdk--option-2 label",function () {
    var stickyOptionChange = $(this).prev().val();
    $(".product-sticky-wrapper .swatches-block.sticky-option-2").find("select").val(stickyOptionChange).change();
    $(".product-sticky-wrapper .sticky-option-2 .cdk-selected-option_item").text(stickyOptionChange);
  });
  $(document).on("click", ".product-sticky-wrapper .cdk-selected-option:not(.active)", function () {  
    $(".product-sticky-wrapper .swatches-block-box").slideUp();
    $('.product-sticky-wrapper .cdk-selected-option').removeClass("active");
    $(this).addClass("active");
    $(this).next(".swatches-block-box").show();
  });
  $(document).on("click", ".product-sticky-wrapper .cdk-selected-option.active", function () {
    $('.product-sticky-wrapper .cdk-selected-option').removeClass("active");
    $(".product-sticky-wrapper .swatches-block-box").hide();
  });
  $(document).on("click", ".product-sticky-wrapper .swatches-block-box .swatches-option", function () {
    var thisText = $(this).text();
    $(this).parents(".swatches-block-box").hide();
    // $(this).next('.swatches-block-box').toggle();
    $(this).parents(".swatches-block").find(".cdk-selected-option .cdk-selected-option_item").text(thisText);
    $(this).parents(".swatches-block-box").prev('.cdk-selected-option').removeClass('active');
  });
});

    // Product sticky bar
   $(document).on("change",".pf-variant-select",function () {
     var id_of_p =  $(this).find('option:selected').attr('value');
      $('.addtocart_sticky').attr('data-variant',id_of_p);
      $('.ProductPrice-sticky').addClass('hidden');
      $('.ProductPrice-sticky[var-id="' + id_of_p + '"]').removeClass('hidden');
      $('.pro_sticky_img').addClass('hidden');
      $('.pro_sticky_img[var-id="' + id_of_p + '"]').removeClass('hidden');
     $('.poff').text($('.ProductPrice-sticky[var-id="' + id_of_p + '"]').attr('poff')+'% OFF');
     $('#mystickyselector option[value="' + id_of_p + '"]').prop('selected', true);
  });
   $(document).on("change","#mystickyselector",function () {
     var id_of_p =  $(this).find('option:selected').attr('value');
      $('.addtocart_sticky').attr('data-variant',id_of_p);
      $('.ProductPrice-sticky').addClass('hidden');
      $('.ProductPrice-sticky[var-id="' + id_of_p + '"]').removeClass('hidden');
      $('.pro_sticky_img').addClass('hidden');
      $('.pro_sticky_img[var-id="' + id_of_p + '"]').removeClass('hidden');
     $('.poff').text($('.ProductPrice-sticky[var-id="' + id_of_p + '"]').attr('poff')+'% OFF');
  });

   $(document).on("click",".addtocart_sticky",function () {
     event.preventDefault();    
    
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;  
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { "id": variantId, "quantity": quantity,"selling_plan":document.querySelector('#atcsp').getAttribute('value')},
      dataType: "json",
      success: function(data){  
        $('body').addClass('overflow-hidden');
        updateMiniCart(); 
        cartCount();
        
        setTimeout(function () {  
          if(!(document.querySelector('.drawer__inner-empty.is-empty') && document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
            upSellslider();
          }
          
          $('.cdkCart-wrapper').removeClass('is-empty');
          $('.cdkCart-wrapper').addClass('active');
          
        },1500);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { console.log(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { console.log(jqXHR.responseJSON.description); }
      }
    });


     
});

$('[data-pf-type="ProductATC2"]').click(function() {
  setTimeout(function () {            
          $('.cdkCart-wrapper').removeClass('is-empty');
          $('.cdkCart-wrapper').addClass('active');
          
        },3000);
});
$('#cusatc').click(function() {       
  var productId = $('input[name="id"]').val();
    $(this).text('Adding...');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: productId
      },
      dataType: 'json',
      success: function(response) {
       $(this).text('Thank You');
        

          fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newBox;
  })
$('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
        
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.error('Error adding product to cart:', errorThrown);
      }
    });
  setTimeout(function () { 
upSellslider();     
  },1500);
                
          $(this).text('👉 ADD TO CART NOW');
       
});

$(document).ready(function() {
  $(document).on("click",".cart-drawer__overlay",function () {
          $('.cdkCart-wrapper').removeClass('active');
          $('body').removeClass('overflow-hidden');
});
  });

  $(document).ready(function () {
  $('.hasupsell').on('click', function(e) {
    e.preventDefault();
    $('.modal.fcc').addClass('is-visible');
  });
    
  
  $('#CartDrawer-Overlay,.drawer__close').on('click', function(e) {
$('body').classList.remove('overflow-hidden');
    
  });



    
$('.usv').on('change', function() {
        var selectedOption = $(this).find('option:selected');
        var vpValue = selectedOption.attr('vp');
        $('.us-price').text(vpValue);

        var vimgValue = selectedOption.attr('vimg');
        $('.us-img').attr('src', vimgValue);
    });
$('.us-atc').on('click', function() {
  $('.us-atc').addClass('activee');
        var vid = $('select.usv option:selected').attr('vid');
        var customVid = $('.cdk-custom-change').val();
       // var name = document.querySelector('.usp-content h3').textContent + document.querySelector('.product__title h1').textContent;
        $.post('/cart/clear.js', function() {
            $.post('/cart/add.js', { id: vid, quantity: 1 }, function() {
                $.post('/cart/add.js', { id: customVid, quantity: 1 }, function() {
     let total = 0;                
const pp = parseFloat($('.us-price').attr('pp')) || 0; 
    const up = parseFloat($('.us-price').attr('up')) || 0;
total += pp + up;
                  /*
                  gtag('event', 'add_to_cart', {
        currency: $('.us-price').attr('sc'), 
        value: total, 
        items: [
            {
                item_name: document.querySelector('.product__title h1').textContent,
                item_id: vid, 
                price: $('.us-price').attr('pp'), 
                quantity: 1,
            },
            {
                item_name: document.querySelector('.usp-content h3').textContent,
                item_id: customVid,
                price: $('.us-price').attr('up'), 
                quantity: 1,
            }
        ]
    });
fbq('track', 'AddToCart', {
    value: total,
    currency: currency,
    contents: [
        {
            id: vid, 
            name: productName1,
            price: pp,
            quantity: 1,
        },
        {
            id: customVid,
            name: productName2,
            price: up,
            quantity: 1,
        }
    ],
    content_type: 'product_group'
});
ttq.track('AddToCart', {
    currency: currency,
    value: total,
    contents: [
        {
            id: vid,
            name: productName1,
            price: pp,
            quantity: 1,
        },
        {
            id: customVid,
            name: productName2,
            price: up,
            quantity: 1,
        }
    ],
    content_type: 'product_group'
});
*/
                  
                  if($('.us-atc').hasClass("co")){
                     window.location.href = '/checkout';
                  }else{
                    fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newBox;
    $('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
     $('.us-atc').removeClass('activee');
  });
                  }
                   
                });
            });
        });
    });

    
  });




// equal height parent how to use new
$(document).ready(function () {
    function setEqualHeight() {
        if ($(window).width() > 786) {
            $('.htuitems').each(function () {
                let maxHeight = 0;
                $(this).find('.htuitem .htui span').each(function () {
                    let height = $(this).height();
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                $(this).find('.htuitem .htui span').height(maxHeight);
            });
        } else {
            $('.htuitems .htuitem .htui span').css('height', '');
        }
    }
    setEqualHeight();
    $(window).resize(function () {
        setEqualHeight();
    });
});

//tabs section
$(".before-after-tab-heading .tab-item").click(function() {
	var dataTab = $(this).data("tab");
	$(this).addClass("aactive");
      $(this).parents(".before-after-tab").find("#" + dataTab).addClass("aactive");
      $(this).siblings().removeClass("aactive");
      $(this).parents(".before-after-tab").find("#" + dataTab).siblings().removeClass("aactive");
})


//new collection template
$(document).ready(function () {
  
   $('.add').click(function () {
        let $input = $(this).siblings('.quantity--input__input');
        let currentValue = parseInt($input.val()) || 0; 
        $input.val(currentValue + 1);
          let newv = currentValue + 1;
         const basePrice = parseFloat($(this).parents('form').find('.onetime .anc-price span').attr('bp'));
         const subPrice = parseFloat($(this).parents('form').find('.ancsubprice').attr('pr'));
        $(this).parents('form').find('.onetime .anc-price span').text($('.anc-frequency').attr('sc')+(basePrice*newv).toLocaleString());
      $(this).parents('form').find('.ancsubprice').text($('.anc-frequency').attr('sc')+(newv*subPrice).toLocaleString());
      $(this).parents('.s-p').find('.sppr').text($(this).parents('form').find('.ancactive .anc-price').text());
   
    });

    $('.sub').click(function () {
        let $input = $(this).siblings('.quantity--input__input'); 
        let currentValue = parseInt($input.val()) || 0; 
        if (currentValue > 1) {
            $input.val(currentValue - 1); 
          let newv = currentValue - 1;
         const basePrice = parseFloat($(this).parents('form').find('.onetime .anc-price span').attr('bp'));
         const subPrice = parseFloat($(this).parents('form').find('.ancsubprice').attr('pr'));
        $(this).parents('form').find('.onetime .anc-price span').text($('.anc-frequency').attr('sc')+(basePrice*newv).toLocaleString());
      $(this).parents('form').find('.ancsubprice').text($('.anc-frequency').attr('sc')+(newv*subPrice).toLocaleString());
      $(this).parents('.s-p').find('.sppr').text($(this).parents('form').find('.ancactive .anc-price').text());
        }
    });
  $(document).ready(function () {
    $('slider-component .quan-atc > form').each(function () {
        var sellingPlanInput = $(this).find('[name="selling_plan"]');
        if (sellingPlanInput.length === 0) {
            var inputElement = document.createElement("input");
            inputElement.type = "hidden";
            inputElement.setAttribute("data-sls-selling_plan", "");
            inputElement.name = "selling_plan";
            var selectedValue = $(this).find('.anc-frequency option:selected').attr('value');
            inputElement.value = selectedValue;
            $(this).append(inputElement);
        } else {
            var selectedValue = $(this).find('.anc-frequency option:selected').attr('value');
            sellingPlanInput.val(selectedValue);
            
        }
    });
});

 $(document).on('click', '.pvar', function () {
  $(this).parents('.s-p').find('.pvar').removeClass('active');
  $(this).addClass('active');  
  $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).attr('vid'));
  $(this).parents('.s-p').find('.sppr').text($(this).attr('vp'));
  $(this).parents('.s-p').find('.spcompr').text($(this).attr('vcp'));
});

 $(document).on('change', '.anc-frequency', function () {
    var saveValue = $(this).find('option:selected').attr('save');
    var imgurl = $(this).find('option:selected').attr('vimg');
    if(imgurl){
      $(this).closest('.s-p').find('.img1').attr('src',imgurl);
    }
    $(this).closest('.sbi-i').find('.anc-group-title span').text(saveValue);
    var sellingPlanInput = $(this).parents('form').find('[data-sls-selling_plan]');
    $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).find('option:selected').attr('vid'))
    if (sellingPlanInput.length > 0) {
        sellingPlanInput.val($(this).find('option:selected').attr('value'));
    } else {
        var inputElement = document.createElement("input");
        inputElement.type = "hidden";
        inputElement.setAttribute("data-sls-selling_plan", "");
        inputElement.name = "selling_plan";
        inputElement.value = $(this).find('option:selected').attr('value');
        inputElement.classList.add("your-class");
        $(this).parents('form').append(inputElement);
    }

    var basePrice = parseFloat($(this).find('option:selected').attr('bfinalprice'));
    var discountPercentage = parseInt(saveValue);
    var totalDiscount = basePrice - (basePrice * (discountPercentage / 100));
    var quan = parseInt($(this).parents('form').find('.quantity--input__input').val());      
    var t = quan * basePrice;
    
    $(this).parents('form').find('.ancsubprice').attr('pr', t);
    $(this).parents('form').find('.ancsubprice,.sppr').text($(this).attr('sc') + t.toFixed(2).toLocaleString());
      $(this).parents('.s-p').find('.spcompr').text($(this).find('option:selected').attr('totalprice'));


      



  });

    
    $(document).on('click', '.sbi', function () {
    $(this).siblings('.sbi').removeClass('ancactive');    
    $(this).addClass('ancactive');
    
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 0){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p1'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p1c'));
    }
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 1){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p2'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p2c'));
    }
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 2){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p3'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p3c'));
    }
    if($(this).hasClass('onetime')){
      $(this).parents('.s-p').find('.pvars').removeClass('hidden');
      $(this).parents('form').find('[data-sls-selling_plan]').attr('value','');
      $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).attr('vid'));
    }else{
      $(this).parents('.s-p').find('.pvars').addClass('hidden');
      $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).find('option:selected').attr('vid'))
      $(this).parents('.s-p').find('.sppr').text($(this).find('select option:selected').attr('finalprice'));
      $(this).parents('form').find('[data-sls-selling_plan]').attr('value',$(this).find('select option:selected').attr('value'));
     }  
});
    
    $('.quan-atc').each(function(){
      const basePrice = parseFloat($(this).find('.onetime .anc-price span').attr('bp'));
      const discountPercentage = parseInt($(this).find('select option:selected').attr('save'));
      const totalDiscount = basePrice - (basePrice * (discountPercentage / 100));
      var quan = parseInt($(this).find('.quantity--input__input').val());      
      var t = quan * totalDiscount;
      $(this).find('.ancsubprice').attr('pr',t);
      $(this).find('.ancsubprice').text($(this).find('select').attr('sc')+t.toFixed(2).toLocaleString());
    })
  });


// selling plan subscripton in drawer
$(document).ready(function () {
  $(document).on('change', '.mysellplan', function (event) {
    event.preventDefault();
    $clicked = $(this).parents('.cart-item');
    $clicked.css('opacity','0.4');
    
        let variantId = $(this).attr('vid');
        let sellingPlanId = $(this).attr('selid');
        let checked = $(this).is(':checked');

        let updateData = {
            id: variantId,
            quantity: 1
        };

        if (checked) {
            updateData.selling_plan = sellingPlanId; // Add selling plan
        } else {
            updateData.selling_plan = null; 
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: updateData,
            dataType: 'json',
            success: function (cart) {
                 fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#"+$clicked.attr('id')).innerHTML;
    document.querySelector("#"+$clicked.attr('id')).innerHTML = newBox;
    document.querySelector(".totals__subtotal-value").innerHTML = html.querySelector(".totals__subtotal-value").innerHTML;
    $clicked.css('opacity','1');
  })
            },
            error: function (error) {
                console.error("Error updating cart", error);
              $clicked.css('opacity','1');
            }
        });
    });
});


 $(document).on('click', '.puropt.sp:not(.newd)', function () {
    $('.puropt').removeClass('active');
    $(this).addClass('active');
    $('.showhide').slideUp();
    $('.offer').removeClass('sub').addClass('sin');
    $ddd = $('.offer.active');
    $('.savedp').text($ddd.attr('yousave'));
    $('.yousaved').text($ddd.attr('saleprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    document.querySelector('input[name="selling_plan"]').value = "";
    $('.buytext strong').text(window.buytext);
 });

 $(document).on('click', '.puropt.sands:not(.newd)', function () {
    $('.puropt').removeClass('active');
      $(this).addClass('active');
   $('.showhide').slideDown();
   $ddd = $('.offer.active'); 
    document.querySelector('input[name="selling_plan"]').value =$ddd.attr('sp');
    $('.offer').addClass('sub').removeClass('sin');
     $('.yousaved').text($ddd.attr('finalprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    $('.savedp').text($ddd.attr('finalpricesaved'));
    $('.buytext strong').text(window.buytext);
 });

 $(document).on('click', '.newd.sp', function () {
    $(this).addClass('sands').removeClass('sp').addClass('active');
   $('.showhide').slideDown();
   $ddd = $('.offer.active');
    document.querySelector('input[name="selling_plan"]').value =$ddd.attr('sp');
    $('.offer').addClass('sub').removeClass('sin');
     $('.yousaved').text($ddd.attr('finalprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    $('.savedp').text($ddd.attr('finalpricesaved'));
    $('.buytext strong').text(window.buytext);
 });
 $(document).on('click', '.newd.sands', function () {
    $(this).addClass('sp').removeClass('sands').removeClass('active');
    $('.showhide').slideUp();
    $('.offer').removeClass('sub').addClass('sin');
    $ddd = $('.offer.active');
    $('.savedp').text($ddd.attr('yousave'));
    $('.yousaved').text($ddd.attr('saleprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    document.querySelector('input[name="selling_plan"]').value = "";
    $('.buytext strong').text(window.buytext);
 });
 $(document).on('click', '.offer', function () {
    $('.offer').removeClass('active');
      $(this).addClass('active');
 });


 $(document).on('click', '.p1', function () {
  $('.dele').text(window.spd1);
   $('.savep').text(window.p1save);
   if($(this).hasClass('sin')){
    $('.savedp').text($(this).attr('yousave'));
    $('.yousaved').text($(this).attr('saleprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
   }else{
    $('.yousaved').text($(this).attr('finalprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
    $('.savedp').text($(this).attr('finalpricesaved'));
   }
 });
 
 $(document).on('click', '.p2', function () {
  $('.dele').text(window.spd2);
   $('.savep').text(window.p2save);
   if($(this).hasClass('sin')){
    $('.savedp').text($(this).attr('yousave'));
    $('.yousaved').text($(this).attr('saleprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
   }else{
    $('.yousaved').text($(this).attr('finalprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
    $('.savedp').text($(this).attr('finalpricesaved'));
   }
 });

 $(document).on('click', '.p3', function () {
  $('.dele').text(window.spd3);
   $('.savep').text(window.p3save);
   if($(this).hasClass('sin')){
    $('.savedp').text($(this).attr('yousave'));
    $('.yousaved').text($(this).attr('saleprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
   }else{
    $('.yousaved').text($(this).attr('finalprice'));
    $('.yourtotal').text($(this).attr('totalprice'));
    $('.savedp').text($(this).attr('finalpricesaved'));
   }
 });

$(document).on('click', '.offer', function () {
 const quantityLabel = document.querySelector(`gp-product-variants [option-name="Quantity"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabel){
   quantityLabel.click();
   }
 const quantityLabel3 = document.querySelector(`gp-product-variants [option-name="Bundles"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabel3){
   quantityLabel3.click();
   }
 const quantityLabelnew = document.querySelector(`gp-product-variants [option-name="Bundle"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabelnew){
   quantityLabelnew.click();
   }
      const quantityLabel2 = document.querySelector(`.product-form__input input[value="`+$(this).attr('vt')+`"]+label`);
      if(quantityLabel2){
   quantityLabel2.click();
   }
   console.log('ddddd',quantityLabel);
});
 


$(document).ready(function () {
  const quantityLabel = document.querySelector(`gp-product-variants [option-name="Quantity"] label [option-name-value="1-PACK"] > div`);
  if(quantityLabel){
   quantityLabel.click();
   }
 $(document).on('click', '.cusatc', function (e) {
  e.preventDefault();
  $clicked = $(this);
  //fbq('trackCustom', 'BuyButtonClick', {    
  //});
   $clicked.addClass('loading');
  var $offer = $('.offer.active');
  if ($offer.length === 0) {
    console.warn('No active offer found');
    return;
  } 
 
  var variantId = $offer.attr('vid');
  var sellingPlanId = $offer.hasClass('sub') ? $offer.attr('sp') : null;
   const connectVariantId = $clicked.attr('connect');
   const itemsToAdd = [
    {
      id: variantId,
      quantity: 1,
    properties: {
      _combo_id: 'anccombo'
    },
      ...(sellingPlanId && { selling_plan: sellingPlanId })
    }
  ];

  if (connectVariantId) {
    itemsToAdd.push({
      id: connectVariantId,
      quantity: 1,
    properties: {
      _combo_id: 'anccombo'
    }
    });
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: itemsToAdd }),
    dataType: 'json',
    contentType: 'application/json',
    success: function (response) {
       fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    let ddd = document.querySelector("#CartDrawer");
    if(ddd){
      if($clicked.hasClass('checkout')){
           window.location.href = '/checkout';
      }else{

document.querySelector("#CartDrawer").innerHTML = newBox;
    $('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
      }
    }else{
      window.location.href = '/checkout';
    }
    
  });
      $clicked.removeClass('loading');
    },
    error: function (xhr, status, error) {
      console.error('Error adding to cart:',xhr,status, error);
      $clicked.removeClass('loading');
    }
  });
});
 });



 $(document).ready(function () {
   $(document).on('click', '.subonly .offer', function () {    
    $('.icon_w_text_text span').text($(this).find('.deler').text());
   }); 
   $(document).on('click', '.hp .p1', function () {    
    document.querySelector('[data-media-position="3"] button').click();
    $('.icon_w_text_text span').text($(this).find('.dele2').text());
   }); 
  
  
   $(document).on('click', '.hp .p2', function () {    
    document.querySelector('[data-media-position="2"] button').click();
   }); 
  
  
   $(document).on('click', '.hp .p3', function () {    
    document.querySelector('[data-media-position="1"] button').click();
   }); 
  
  
   
   


  
  });
  












  /*

  function upSellslider(){
  if(!(document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
  if(!(document.querySelector('.drawer__inner-empty.is-empty'))){
    $('.cdk_upsell_slider').slick({
      dots: false,
      infinite: false,
      slidesToShow: 2, 
      slidesToScroll: 1, 
      adaptiveHeight: true,
      prevArrow: '<button class="slide-arrow prev-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
      nextArrow: '<button class="slide-arrow next-arrow"><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 6"><path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></svg></button>',
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll:1,
           arrows: true
          }
        }
      ]
  });
  }
  }
}
  
//Ajax Cart Count Function Start
function cartCount(){ $.getJSON('/cart.js', function(cart) { $(".cart-count-bubble > span").html(cart.item_count); 
    if(cart.item_count >= 1){$('cart-drawer.cdesk-cart-drawer').removeClass('is-empty').addClass('active'); $('body').addClass('overflow-hidden');
    $('#cart-icon-bubble').append('<div class="cart-count-bubble" bis_skin_checked="1"><span aria-hidden="true">'+cart.item_count+'</span><span class="visually-hidden">'+cart.item_count+' items</span></div>')}
    });
}
//  mini cart 
function updateMiniCart(currentThis) {
  $.ajax({
    type: "GET",
    url: "/",
    dataType: "html",

    success: function (data) {
      var miniCartHead = $(data).contents("#CartDrawer").find(".drawer__inner").html();
      $("#CartDrawer .drawer__inner").html(miniCartHead);
      setTimeout(function () {   
          upSellslider();
        },1500);
      
    },
  });
}
//  Ajax Cart Count Function End 
function ajaxAddToCartProduct(currentThis,dynamicData,variantId) {   
 $.post('/cart/add.js', { id: variantId, quantity: 1 }, function() {
   $('body').addClass('overflow-hidden');
        updateMiniCart(currentThis); 
        cartCount();

        setTimeout(function () {   
          upSellslider();
        },1500);
 });
  
  }

$(document).ready(function(){
  // bundle option selected js
  $(document).mouseup(function (e) {
    if ($(e.target).closest(".swatches-block-box").length === 0) {
        $(".swatches-block-box").removeClass('open');
    }
  });
  
  $(document).on('click','.swatches-block .option_label', function () {
    $(this).next('.swatches-block-box').addClass('open');
  })
  $(document).on('click','.cdk_upsell_outer .swatches-block .swatches-item-box .swatches-option', function () {
    var OptionName = $(this).attr('data-value');
    $(this).parents('.swatches-item-box').find('.swatches-option').removeClass('selected');
    $(this).addClass('selected');
    $(this).parents('.swatches-block').find('select').val(OptionName).change();
    $(this).parents('.swatches-block-box').removeClass('open');
    if(window.innerWidth < 788){
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName.substring(0, 13)+'...');
    }else{
    $(this).parents('.swatches-block').find('.option_label .color_name_indicator').text(OptionName);
    }
  })

 
  $(document).on('change','.cdk_upsell_outer .swatches-block select', function () {
    var FinalValue = '';
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    
    $('.product-swatches[data-id="'+thisParentId+'"] .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
    });
    $(this).parents('.card__content').find('.ancprice').hide();
    $('.ancprice[ var-id="' + $(this).find('option:selected').attr('v-id') + '"]').show();
    
      $(this).parents('.card-wrapper').find('.card__media').addClass('hidden');
      $(this).parents('.card-wrapper').find('.card__media[v-id="' + $(this).find('option:selected').attr('v-id') + '"]').removeClass('hidden');
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    $(this).parents('.swatches-block').find('.option_label').css('font-size','0');
    $(this).parents('.swatches-block').find('.option_label').find('span').css('display','block');     
    var optionName_Selector = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select option[check-data-sku="'+newstr+'"]');
    var optionName_val = optionName_Selector.val(); 
    $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val(optionName_val).change(); 
  });
  $(document).on('change','.cdk_upsell_outer .product-swatches select.product_card-form__master-select', function () {
$(this).parents('.card-wrapper').find('.card__media').addClass('hidden');
      $(this).parents('.card-wrapper').find('.card__media[v-id="' + $(this).find('option:selected').attr('value') + '"]').removeClass('hidden');
    $(this).parents('.card__content').find('.ancprice').hide();
    $('.ancprice[ var-id="' + $(this).find('option:selected').attr('value') + '"]').show();
    
    var thisMainVal = $(this).val(); 
    var thisParentId = $(this).parents('.product-swatches').attr('data-id');
    // console.log('thisMainVal::'+thisMainVal);
    var ThisSellingPlan = $('.product-swatches[data-id="'+thisParentId+'"] select.product_card-form__master-select').val();
    // console.log('ThisSellingPlan::'+ThisSellingPlan);
    var ThisProdAvail =$(this).find('option[value="'+thisMainVal+'"]').attr('data-varaint-availability');
    // console.log('ThisProdAvail::'+ThisProdAvail);
      $('.upsell-addto-cart').attr('data-variant',ThisSellingPlan);
      
  });
$(document).on('click','.upsell-addto-cart',function(){   
  var currentThis = $(this);
  var updateItems = [];
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;
  updateItems.push({ "id": variantId, "quantity": quantity});
  ajaxAddToCartProduct(currentThis,updateItems,variantId);
  setTimeout(function () {   
      upSellslider();
    },1500);  
});
$(document).on("click", ".cdkCart-wrapper cart-remove-button button", function (event) {
    event.preventDefault();    
    var vId = $(this).parents(".cart-item__quantity-wrapper").find('.quantity__input').attr('data-quantity-variant-id');      
   $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      dataType: 'json',
     data: {
    'id': parseFloat(vId),
    'quantity': 0
    }
   })
   .then(data => {
     $(this).parents('.cart-item').remove();
     var Lenght = $('.cart-items .cart-item').length;
     cartCount();
     updateMiniCart();
     if (Lenght == 0){
       $('cart-drawer.cdkCart-wrapper').addClass('is-empty');
     }
     setTimeout(function () {   
        upSellslider();
      },1000);
  })
  });
$(document).on("change", ".cdkCart-wrapper .cart-quantity .quantity__input", function () {   
    var vId = $(this).attr('data-quantity-variant-id'); 
    var itemValue = $(this).val();
   $.ajax({
      url: '/cart/change.js',
      type: 'POST',
      data: {'id': vId,
    'quantity': itemValue},
      success: function(data) { 
         cartCount();
         updateMiniCart();
        setTimeout(function () {   
          upSellslider();
        },1500);
      },
      error: function(jqxhr, status, exception) {
      } 
    })
});
  $(document).on("click","#addToCart",function () {
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;  
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { "id": variantId, "quantity": quantity},
      dataType: "json",
      success: function(data){  
        $('body').addClass('overflow-hidden');
        updateMiniCart(); 
        cartCount();
        
        setTimeout(function () {  
            
          upSellslider();
          
          $('.cdkCart-wrapper').addClass('active');
          
        },1500);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { alert(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { alert(jqXHR.responseJSON.description); }
      }
    });




    
  });
$(document).on('click', '.product-form__submit,.header__icon--cart', function(){
  if(!(document.querySelector('.drawer__inner-empty.is-empty') && document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
  setTimeout(function () {   
    upSellslider();
  },1000);
  }
}) 
 $(document).on('click', '.pf-product-form button', function(){ 
   $('body').addClass('overflow-hidden'); 
  setTimeout(function () {   
    upSellslider();
  },1500);
});

// Product sticky bar
 $(document).on("click",".product-sticky-wrapper .swatches-block .swatches-item-box .swatches-option",function () {
    var OptionName = $(this).attr("data-value");
    $(this).parents(".swatches-item-box").find(".swatches-option").removeClass("selected");
    $(this).addClass("selected");
    $(this).parents(".swatches-block").find("select").val(OptionName).change();
    
});

  $(document).on("change",".product-sticky-wrapper  .swatches-block select.cdk-select",function () {
    var FinalValue = "";
    $('.product-sticky-wrapper .swatches-block').each(function() {
      var selectVal = $(this).find('select').val();
      FinalValue += selectVal+' / ';
    });
    
    var newstr = FinalValue.substring(0, FinalValue.length - 3);
    var optionName_Selector = $('.product-sticky-wrapper select.product_card-form__master-select option[check-data-sku="' +newstr +'"]');
    var optionName_val = optionName_Selector.val();
    $('.product-sticky-wrapper select.product_card-form__master-select').val(optionName_val).change();
  });


  
  $(document).on("change",".product-sticky-wrapper select.product_card-form__master-select",function () {
      var thisMainVal = $(this).val();
      var ThisProdAvail = $(this).find('option[value="' + thisMainVal + '"]').attr("data-varaint-availability");
      var ThisProdNP = $(this).find('option[value="' + thisMainVal + '"]').attr("data-price");
      $(this).parents('.product-sticky-wrapper').find(".cdk_quick_price").find(".price-item.price-item--regular").text(ThisProdNP);
      $('.cdk_custom_add').attr("data-variant",thisMainVal);
      $('.cdk-custom-change').attr('value',thisMainVal);
      if (ThisProdAvail == "true") {
        $('.cdk_custom_add').attr("data-btn","addToCart");
        $('.cdk_custom_add').find(".btn_text").text("Add To Cart");
      } else {
        $('.cdk_custom_add').find(".btn_text").text("Sold Out");
        $('.cdk_custom_add').attr("data-btn","soldout");
      }
    });
  $(document).on("click","fieldset.cdk--option-1 label",function () {
    var stickyOptionChange = $(this).prev().val();
    $(".product-sticky-wrapper .swatches-block.sticky-option-1").find("select").val(stickyOptionChange).change();
    $(".product-sticky-wrapper .sticky-option-1 .cdk-selected-option_item").text(stickyOptionChange);
  });
  $(document).on("click","fieldset.cdk--option-2 label",function () {
    var stickyOptionChange = $(this).prev().val();
    $(".product-sticky-wrapper .swatches-block.sticky-option-2").find("select").val(stickyOptionChange).change();
    $(".product-sticky-wrapper .sticky-option-2 .cdk-selected-option_item").text(stickyOptionChange);
  });
  $(document).on("click", ".product-sticky-wrapper .cdk-selected-option:not(.active)", function () {  
    $(".product-sticky-wrapper .swatches-block-box").slideUp();
    $('.product-sticky-wrapper .cdk-selected-option').removeClass("active");
    $(this).addClass("active");
    $(this).next(".swatches-block-box").show();
  });
  $(document).on("click", ".product-sticky-wrapper .cdk-selected-option.active", function () {
    $('.product-sticky-wrapper .cdk-selected-option').removeClass("active");
    $(".product-sticky-wrapper .swatches-block-box").hide();
  });
  $(document).on("click", ".product-sticky-wrapper .swatches-block-box .swatches-option", function () {
    var thisText = $(this).text();
    $(this).parents(".swatches-block-box").hide();
    // $(this).next('.swatches-block-box').toggle();
    $(this).parents(".swatches-block").find(".cdk-selected-option .cdk-selected-option_item").text(thisText);
    $(this).parents(".swatches-block-box").prev('.cdk-selected-option').removeClass('active');
  });
});

    // Product sticky bar
   $(document).on("change",".pf-variant-select",function () {
     var id_of_p =  $(this).find('option:selected').attr('value');
      $('.addtocart_sticky').attr('data-variant',id_of_p);
      $('.ProductPrice-sticky').addClass('hidden');
      $('.ProductPrice-sticky[var-id="' + id_of_p + '"]').removeClass('hidden');
      $('.pro_sticky_img').addClass('hidden');
      $('.pro_sticky_img[var-id="' + id_of_p + '"]').removeClass('hidden');
     $('.poff').text($('.ProductPrice-sticky[var-id="' + id_of_p + '"]').attr('poff')+'% OFF');
     $('#mystickyselector option[value="' + id_of_p + '"]').prop('selected', true);
  });
   $(document).on("change","#mystickyselector",function () {
     var id_of_p =  $(this).find('option:selected').attr('value');
      $('.addtocart_sticky').attr('data-variant',id_of_p);
      $('.ProductPrice-sticky').addClass('hidden');
      $('.ProductPrice-sticky[var-id="' + id_of_p + '"]').removeClass('hidden');
      $('.pro_sticky_img').addClass('hidden');
      $('.pro_sticky_img[var-id="' + id_of_p + '"]').removeClass('hidden');
     $('.poff').text($('.ProductPrice-sticky[var-id="' + id_of_p + '"]').attr('poff')+'% OFF');
  });

   $(document).on("click",".addtocart_sticky",function () {
     event.preventDefault();    
    
  var variantId =  $(this).attr('data-variant');
  var quantity = 1;  
    $.ajax({
      url: "/cart/add.js",
      type: "POST",
      data: { "id": variantId, "quantity": quantity,"selling_plan":document.querySelector('#atcsp').getAttribute('value')},
      dataType: "json",
      success: function(data){  
        $('body').addClass('overflow-hidden');
        updateMiniCart(); 
        cartCount();
        
        setTimeout(function () {  
          if(!(document.querySelector('.drawer__inner-empty.is-empty') && document.querySelector('.cdk_upsell_slider.slick-initialized.slick-slider'))){
            upSellslider();
          }
          
          $('.cdkCart-wrapper').removeClass('is-empty');
          $('.cdkCart-wrapper').addClass('active');
          
        },1500);
      },
      error: function(jqXHR, textStatus, errorThrown) {
        if(jqXHR.status == 400) { console.log(jqXHR.responseJSON.message); }
        if(jqXHR.status == 422) { console.log(jqXHR.responseJSON.description); }
      }
    });


     
});

$('[data-pf-type="ProductATC2"]').click(function() {
  setTimeout(function () {            
          $('.cdkCart-wrapper').removeClass('is-empty');
          $('.cdkCart-wrapper').addClass('active');
          
        },3000);
});
$('#cusatc').click(function() {       
  var productId = $('input[name="id"]').val();
    $(this).text('Adding...');
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: {
        quantity: 1,
        id: productId
      },
      dataType: 'json',
      success: function(response) {
       $(this).text('Thank You');
        

          fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newBox;
  })
$('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
        
      },
      error: function(XMLHttpRequest, textStatus, errorThrown) {
        console.error('Error adding product to cart:', errorThrown);
      }
    });
  setTimeout(function () { 
upSellslider();     
  },1500);
                
          $(this).text('👉 ADD TO CART NOW');
       
});

$(document).ready(function() {
  $(document).on("click",".cart-drawer__overlay",function () {
          $('.cdkCart-wrapper').removeClass('active');
          $('body').removeClass('overflow-hidden');
});
  });

  $(document).ready(function () {
  $('.hasupsell').on('click', function(e) {
    e.preventDefault();
    $('.modal.fcc').addClass('is-visible');
  });
    
  
  $('#CartDrawer-Overlay,.drawer__close').on('click', function(e) {
$('body').classList.remove('overflow-hidden');
    
  });



    
$('.usv').on('change', function() {
        var selectedOption = $(this).find('option:selected');
        var vpValue = selectedOption.attr('vp');
        $('.us-price').text(vpValue);

        var vimgValue = selectedOption.attr('vimg');
        $('.us-img').attr('src', vimgValue);
    });
$('.us-atc').on('click', function() {
  $('.us-atc').addClass('activee');
        var vid = $('select.usv option:selected').attr('vid');
        var customVid = $('.cdk-custom-change').val();
       // var name = document.querySelector('.usp-content h3').textContent + document.querySelector('.product__title h1').textContent;
        $.post('/cart/clear.js', function() {
            $.post('/cart/add.js', { id: vid, quantity: 1 }, function() {
                $.post('/cart/add.js', { id: customVid, quantity: 1 }, function() {
     let total = 0;                
const pp = parseFloat($('.us-price').attr('pp')) || 0; 
    const up = parseFloat($('.us-price').attr('up')) || 0;
total += pp + up;
                 
                  
                  if($('.us-atc').hasClass("co")){
                     window.location.href = '/checkout';
                  }else{
                    fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    document.querySelector("#CartDrawer").innerHTML = newBox;
    $('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
     $('.us-atc').removeClass('activee');
  });
                  }
                   
                });
            });
        });
    });

    
  });




// equal height parent how to use new
$(document).ready(function () {
    function setEqualHeight() {
        if ($(window).width() > 786) {
            $('.htuitems').each(function () {
                let maxHeight = 0;
                $(this).find('.htuitem .htui span').each(function () {
                    let height = $(this).height();
                    if (height > maxHeight) {
                        maxHeight = height;
                    }
                });
                $(this).find('.htuitem .htui span').height(maxHeight);
            });
        } else {
            $('.htuitems .htuitem .htui span').css('height', '');
        }
    }
    setEqualHeight();
    $(window).resize(function () {
        setEqualHeight();
    });
});

//tabs section
$(".before-after-tab-heading .tab-item").click(function() {
	var dataTab = $(this).data("tab");
	$(this).addClass("aactive");
      $(this).parents(".before-after-tab").find("#" + dataTab).addClass("aactive");
      $(this).siblings().removeClass("aactive");
      $(this).parents(".before-after-tab").find("#" + dataTab).siblings().removeClass("aactive");
})


//new collection template
$(document).ready(function () {
  
   $('.add').click(function () {
        let $input = $(this).siblings('.quantity--input__input');
        let currentValue = parseInt($input.val()) || 0; 
        $input.val(currentValue + 1);
          let newv = currentValue + 1;
         const basePrice = parseFloat($(this).parents('form').find('.onetime .anc-price span').attr('bp'));
         const subPrice = parseFloat($(this).parents('form').find('.ancsubprice').attr('pr'));
        $(this).parents('form').find('.onetime .anc-price span').text($('.anc-frequency').attr('sc')+(basePrice*newv).toLocaleString());
      $(this).parents('form').find('.ancsubprice').text($('.anc-frequency').attr('sc')+(newv*subPrice).toLocaleString());
      $(this).parents('.s-p').find('.sppr').text($(this).parents('form').find('.ancactive .anc-price').text());
   
    });

    $('.sub').click(function () {
        let $input = $(this).siblings('.quantity--input__input'); 
        let currentValue = parseInt($input.val()) || 0; 
        if (currentValue > 1) {
            $input.val(currentValue - 1); 
          let newv = currentValue - 1;
         const basePrice = parseFloat($(this).parents('form').find('.onetime .anc-price span').attr('bp'));
         const subPrice = parseFloat($(this).parents('form').find('.ancsubprice').attr('pr'));
        $(this).parents('form').find('.onetime .anc-price span').text($('.anc-frequency').attr('sc')+(basePrice*newv).toLocaleString());
      $(this).parents('form').find('.ancsubprice').text($('.anc-frequency').attr('sc')+(newv*subPrice).toLocaleString());
      $(this).parents('.s-p').find('.sppr').text($(this).parents('form').find('.ancactive .anc-price').text());
        }
    });
  $(document).ready(function () {
    $('slider-component .quan-atc > form').each(function () {
        var sellingPlanInput = $(this).find('[name="selling_plan"]');
        if (sellingPlanInput.length === 0) {
            var inputElement = document.createElement("input");
            inputElement.type = "hidden";
            inputElement.setAttribute("data-sls-selling_plan", "");
            inputElement.name = "selling_plan";
            var selectedValue = $(this).find('.anc-frequency option:selected').attr('value');
            inputElement.value = selectedValue;
            $(this).append(inputElement);
        } else {
            var selectedValue = $(this).find('.anc-frequency option:selected').attr('value');
            sellingPlanInput.val(selectedValue);
            
        }
    });
});

 $(document).on('click', '.pvar', function () {
  $(this).parents('.s-p').find('.pvar').removeClass('active');
  $(this).addClass('active');  
  $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).attr('vid'));
  $(this).parents('.s-p').find('.sppr').text($(this).attr('vp'));
  $(this).parents('.s-p').find('.spcompr').text($(this).attr('vcp'));
});

 $(document).on('change', '.anc-frequency', function () {
    var saveValue = $(this).find('option:selected').attr('save');
    var imgurl = $(this).find('option:selected').attr('vimg');
    if(imgurl){
      $(this).closest('.s-p').find('.img1').attr('src',imgurl);
    }
    $(this).closest('.sbi-i').find('.anc-group-title span').text(saveValue);
    var sellingPlanInput = $(this).parents('form').find('[data-sls-selling_plan]');
    $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).find('option:selected').attr('vid'))
    if (sellingPlanInput.length > 0) {
        sellingPlanInput.val($(this).find('option:selected').attr('value'));
    } else {
        var inputElement = document.createElement("input");
        inputElement.type = "hidden";
        inputElement.setAttribute("data-sls-selling_plan", "");
        inputElement.name = "selling_plan";
        inputElement.value = $(this).find('option:selected').attr('value');
        inputElement.classList.add("your-class");
        $(this).parents('form').append(inputElement);
    }

    var basePrice = parseFloat($(this).find('option:selected').attr('bfinalprice'));
    var discountPercentage = parseInt(saveValue);
    var totalDiscount = basePrice - (basePrice * (discountPercentage / 100));
    var quan = parseInt($(this).parents('form').find('.quantity--input__input').val());      
    var t = quan * basePrice;
    
    $(this).parents('form').find('.ancsubprice').attr('pr', t);
    $(this).parents('form').find('.ancsubprice,.sppr').text($(this).attr('sc') + t.toFixed(2).toLocaleString());
      $(this).parents('.s-p').find('.spcompr').text($(this).find('option:selected').attr('totalprice'));


      



  });

    
    $(document).on('click', '.sbi', function () {
    $(this).siblings('.sbi').removeClass('ancactive');    
    $(this).addClass('ancactive');
    
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 0){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p1'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p1c'));
    }
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 1){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p2'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p2c'));
    }
    if($(this).parents('.s-p').find('.anc-frequency').prop('selectedIndex') == 2){
      $(this).parents('.s-p').find('.sppr').text($(this).find('.anc-price span').attr('p3'));
      $(this).parents('.s-p').find('.spcompr').text($(this).find('.anc-price span').attr('p3c'));
    }
    if($(this).hasClass('onetime')){
      $(this).parents('.s-p').find('.pvars').removeClass('hidden');
      $(this).parents('form').find('[data-sls-selling_plan]').attr('value','');
      $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).attr('vid'));
    }else{
      $(this).parents('.s-p').find('.pvars').addClass('hidden');
      $(this).parents('.s-p').find('input[name="id"]').attr('value',$(this).find('option:selected').attr('vid'))
      $(this).parents('.s-p').find('.sppr').text($(this).find('select option:selected').attr('finalprice'));
      $(this).parents('form').find('[data-sls-selling_plan]').attr('value',$(this).find('select option:selected').attr('value'));
     }  
});
    
    $('.quan-atc').each(function(){
      const basePrice = parseFloat($(this).find('.onetime .anc-price span').attr('bp'));
      const discountPercentage = parseInt($(this).find('select option:selected').attr('save'));
      const totalDiscount = basePrice - (basePrice * (discountPercentage / 100));
      var quan = parseInt($(this).find('.quantity--input__input').val());      
      var t = quan * totalDiscount;
      $(this).find('.ancsubprice').attr('pr',t);
      $(this).find('.ancsubprice').text($(this).find('select').attr('sc')+t.toFixed(2).toLocaleString());
    })
  });


// selling plan subscripton in drawer
$(document).ready(function () {
  $(document).on('change', '.mysellplan', function (event) {
    event.preventDefault();
    $clicked = $(this).parents('.cart-item');
    $clicked.css('opacity','0.4');
    
        let variantId = $(this).attr('vid');
        let sellingPlanId = $(this).attr('selid');
        let checked = $(this).is(':checked');

        let updateData = {
            id: variantId,
            quantity: 1
        };

        if (checked) {
            updateData.selling_plan = sellingPlanId; // Add selling plan
        } else {
            updateData.selling_plan = null; 
        }

        $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: updateData,
            dataType: 'json',
            success: function (cart) {
                 fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#"+$clicked.attr('id')).innerHTML;
    document.querySelector("#"+$clicked.attr('id')).innerHTML = newBox;
    document.querySelector(".totals__subtotal-value").innerHTML = html.querySelector(".totals__subtotal-value").innerHTML;
    $clicked.css('opacity','1');
  })
            },
            error: function (error) {
                console.error("Error updating cart", error);
              $clicked.css('opacity','1');
            }
        });
    });
});


 $(document).on('click', '.puropt.sp:not(.newd)', function () {
    $('.puropt').removeClass('active');
    $(this).addClass('active');
    $('.showhide').slideUp();
    $('.offer').removeClass('sub').addClass('sin');
    $ddd = $('.offer.active');
    $('.savedp').text($ddd.attr('yousave'));
    $('.yousaved').text($ddd.attr('saleprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    document.querySelector('input[name="selling_plan"]').value = "";
    $('.buytext strong').text(window.buytext);
 });

 $(document).on('click', '.puropt.sands:not(.newd)', function () {
    $('.puropt').removeClass('active');
      $(this).addClass('active');
   $('.showhide').slideDown();
   $ddd = $('.offer.active'); 
    document.querySelector('input[name="selling_plan"]').value =$ddd.attr('sp');
    $('.offer').addClass('sub').removeClass('sin');
     $('.yousaved').text($ddd.attr('finalprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    $('.savedp').text($ddd.attr('finalpricesaved'));
    $('.buytext strong').text(window.buytext);
 });

 $(document).on('click', '.newd.sp', function () {
    $(this).addClass('sands').removeClass('sp').addClass('active');
   $('.showhide').slideDown();
   $ddd = $('.offer.active');
    document.querySelector('input[name="selling_plan"]').value =$ddd.attr('sp');
    $('.offer').addClass('sub').removeClass('sin');
     $('.yousaved').text($ddd.attr('finalprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    $('.savedp').text($ddd.attr('finalpricesaved'));
    $('.buytext strong').text(window.buytext);
 });
 $(document).on('click', '.newd.sands', function () {
    $(this).addClass('sp').removeClass('sands').removeClass('active');
    $('.showhide').slideUp();
    $('.offer').removeClass('sub').addClass('sin');
    $ddd = $('.offer.active');
    $('.savedp').text($ddd.attr('yousave'));
    $('.yousaved').text($ddd.attr('saleprice'));
    $('.yourtotal').text($ddd.attr('totalprice'));
    document.querySelector('input[name="selling_plan"]').value = "";
    $('.buytext strong').text(window.buytext);
 });
function ancOfferIndex($offer) {
  var match = ($offer.attr('class') || '').match(/\bp(\d+)\b/);
  return match ? match[1] : null;
}

function ancOfferSellingPlan($offer, index) {
  return $offer.attr('sellingplan') || window['p' + index + 'sellingplan'] || window['sp' + index] || window.sp1 || $offer.attr('sp') || '';
}

function ancOfferDescription(sellingPlan, index) {
  if (sellingPlan) {
    for (var i = 1; i <= 50; i++) {
      if (typeof window['sp' + i] === 'undefined') break;
      if (String(window['sp' + i]) === String(sellingPlan)) {
        return window['spd' + i] || '';
      }
    }
  }

  return window['spd' + index] || window.spd1 || '';
}

function ancUpdateOffer($offer) {
  var index = ancOfferIndex($offer);
  if (!index) return;

  var sellingPlan = ancOfferSellingPlan($offer, index);
  var discount = $offer.attr('discountpct');

  if (discount === undefined || discount === null || discount === '') {
    discount = window['p' + index + 'save'];
  }

  if (discount === undefined || discount === null || discount === '') {
    discount = 0;
  }

  if (sellingPlan) {
    $offer.attr('sp', sellingPlan);
  }

  var description = ancOfferDescription(sellingPlan, index);

  if (description) {
    $('.dele').text(description);
  }

  $('.savep').text(discount);

  if ($offer.hasClass('sin')) {
    $('.savedp').text($offer.attr('yousave'));
    $('.yousaved').text($offer.attr('saleprice'));
    $('.yourtotal').text($offer.attr('totalprice'));
  } else {
    $('.yousaved').text($offer.attr('finalprice'));
    $('.yourtotal').text($offer.attr('totalprice'));
    $('.savedp').text($offer.attr('finalpricesaved'));

    var sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && sellingPlan) {
      sellingPlanInput.value = sellingPlan;
    }
  }
}

$(document).ready(function () {
  $('.offer').each(function () {
    var $offer = $(this);
    var index = ancOfferIndex($offer);
    if (!index) return;

    var sellingPlan = ancOfferSellingPlan($offer, index);
    if (sellingPlan) {
      $offer.attr('sp', sellingPlan);
    }
  });

  var $activeOffer = $('.offer.active').first();
  if ($activeOffer.length) {
    ancUpdateOffer($activeOffer);
  }
});

$(document).on('click', '.offer', function () {
  $('.offer').removeClass('active');
  $(this).addClass('active');
  ancUpdateOffer($(this));
});

$(document).on('click', '.offer', function () {
 const quantityLabel = document.querySelector(`gp-product-variants [option-name="Quantity"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabel){
   quantityLabel.click();
   }
 const quantityLabel3 = document.querySelector(`gp-product-variants [option-name="Bundles"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabel3){
   quantityLabel3.click();
   }
 const quantityLabelnew = document.querySelector(`gp-product-variants [option-name="Bundle"] label [option-name-value="`+$(this).attr('vt')+`"] > div`);
   if(quantityLabelnew){
   quantityLabelnew.click();
   }
      const quantityLabel2 = document.querySelector(`.product-form__input input[value="`+$(this).attr('vt')+`"]+label`);
      if(quantityLabel2){
   quantityLabel2.click();
   }
   console.log('ddddd',quantityLabel);
});
 


$(document).ready(function () {
  const quantityLabel = document.querySelector(`gp-product-variants [option-name="Quantity"] label [option-name-value="1-PACK"] > div`);
  if(quantityLabel){
   quantityLabel.click();
   }
 $(document).on('click', '.cusatc', function (e) {
  e.preventDefault();
  $clicked = $(this);
  //fbq('trackCustom', 'BuyButtonClick', {    
  //});
   $clicked.addClass('loading');
  var $offer = $('.offer.active');
  if ($offer.length === 0) {
    console.warn('No active offer found');
    return;
  } 
 
  var variantId = $offer.attr('vid');
  var sellingPlanId = $offer.hasClass('sub') ? $offer.attr('sp') : null;
   const connectVariantId = $clicked.attr('connect');
   const itemsToAdd = [
    {
      id: variantId,
      quantity: 1,
    properties: {
      _combo_id: 'anccombo'
    },
      ...(sellingPlanId && { selling_plan: sellingPlanId })
    }
  ];

  if (connectVariantId) {
    itemsToAdd.push({
      id: connectVariantId,
      quantity: 1,
    properties: {
      _combo_id: 'anccombo'
    }
    });
  }

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: JSON.stringify({ items: itemsToAdd }),
    dataType: 'json',
    contentType: 'application/json',
    success: function (response) {
       fetch("/?section_id=cart-drawer")
  .then(res => res.text())
  .then(data => {
    const html = document.createElement("div");
    html.innerHTML = data;
    const newBox = html.querySelector("#CartDrawer").innerHTML;
    let ddd = document.querySelector("#CartDrawer");
    if(ddd){
      if($clicked.hasClass('checkout')){
           window.location.href = '/checkout';
      }else{

document.querySelector("#CartDrawer").innerHTML = newBox;
    $('.cdkCart-wrapper').removeClass('is-empty');
        $('.cdkCart-wrapper').addClass('active');
        cartCount();
        upSellslider();
      }
    }else{
      window.location.href = '/checkout';
    }
    
  });
      $clicked.removeClass('loading');
    },
    error: function (xhr, status, error) {
      console.error('Error adding to cart:',xhr,status, error);
      $clicked.removeClass('loading');
    }
  });
});
 });



 $(document).ready(function () {
   $(document).on('click', '.subonly .offer', function () {    
    $('.icon_w_text_text span').text($(this).find('.deler').text());
   }); 
   $(document).on('click', '.hp .p1', function () {    
    document.querySelector('[data-media-position="3"] button').click();
    $('.icon_w_text_text span').text($(this).find('.dele2').text());
   }); 
  
  
   $(document).on('click', '.hp .p2', function () {    
    document.querySelector('[data-media-position="2"] button').click();
   }); 
  
  
   $(document).on('click', '.hp .p3', function () {    
    document.querySelector('[data-media-position="1"] button').click();
   }); 
  
  
   
   


  
  });

  */